import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/login",
      name: "Login",
      component: () => import("@/views/auth/Login.vue"),
      meta: {
        layout: "full",
      },
    },
    {
      path: "/user",
      name: "User",
      component: () => import("@/views/user/User.vue"),
      meta: {
        pageTitle: "User",
        breadcrumb: [
          {
            text: "User",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_user",
      },
    },
    {
      path: "/role",
      name: "Role",
      component: () => import("@/views/role/Role.vue"),
      meta: {
        pageTitle: "Role",
        breadcrumb: [
          {
            text: "Role",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_role",
      },
    },
    {
      path: "/payment",
      name: "Payment",
      component: () => import("@/views/payment/Payment.vue"),
      meta: {
        pageTitle: "Payment",
        breadcrumb: [
          {
            text: "Payment",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_payment",
      },
    },
    {
      path: "/config",
      name: "Config",
      component: () => import("@/views/config/Config.vue"),
      meta: {
        pageTitle: "Config",
        breadcrumb: [
          {
            text: "Config",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_config",
      },
    },
    {
      path: "/server",
      name: "Server",
      component: () => import("@/views/server/Server.vue"),
      meta: {
        pageTitle: "Server",
        breadcrumb: [
          {
            text: "Server",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_server",
      },
    },
    {
      path: "/country",
      name: "Country",
      component: () => import("@/views/country/Country.vue"),
      meta: {
        pageTitle: "Country",
        breadcrumb: [
          {
            text: "Country",
            active: true,
          },
        ],
        requiresAuth: true,
        permission: "show_country",
      },
    },
    {
      path: "*",
      redirect: "/login",
    },
  ],
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
